

















































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";
import MyConfig from "@/config";

@Component
export default class extends Mixins(MyForm) {
  @Prop() appid!: string;

  apiserver: string = MyConfig.casapi;
  headers: any = {
    Authorization: window.localStorage.getItem("token")
  };
  formData ={
    type:"1",
    name:"",
    contact_name:"",
    contact_email:"",
    component_phone:"",
  }

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "你确定要发起认证吗？",
          onOk: async () => {
            const res = await this.$store.dispatch("oplatformapps/wxaauth", {
              appid: this.appid,
              ...fieldValues,
            });

            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  mounted() {

  }

  handleUploaded(e: any) {
    // console.log(e);
    if (e.file && e.file.status === "done") {
      const { field } = e.file.response.Data;
      const mediaId = e.file.response.Data.media_id;

      this.form.setFieldsValue({
        [`${field}`]: mediaId
      });
    }
  }

}
